import React from "react";
import { View, Text, Image } from "@react-pdf/renderer";

export default function DgiSection({ S, data }) {
  return (
    <View style={[S.box, { marginTop: 10 }]}>
      <Text style={S.label}>Validación DGI</Text>

      <View style={{ flexDirection: "row", marginTop: 6 }}>

        {/* LADO IZQUIERDO */}
        <View style={{ flex: 1, paddingRight: 12 }}>
          <Text style={S.muted}>
            Consulte por la clave de acceso en:
          </Text>

          <Text
            style={{
              fontSize: 8,
              marginTop: 4,
              wordBreak: "break-all",
            }}
          >
            https://dgi-fep.mef.gob.pa/Consultas/FacturasPorCUFE
          </Text>

          <View style={{ marginTop: 6 }}>
            <Text style={S.bold}>CUFE:</Text>
            <Text>{data.cufe}</Text>
          </View>
        </View>


      </View>
    </View>
  );
}